import {IProductTourStep} from '@toolify/client/src/modules/productTour/types/IProductTourStep'
import {ProductTourAnchorType} from '@toolify/client/src/modules/productTour/enum/ProductTourAnchorType'

// Anchors live on the database page (view header + table); steps whose anchor
// (and fallback) is missing are skipped by the store's step navigation.
export const databaseProductTourSteps: IProductTourStep[] = [
  {
    name: 'welcome',
    anchor: null,
    titleTranslationKey: 'productTour.database.welcome.title',
    descriptionTranslationKey: 'productTour.database.welcome.description',
  },
  {
    name: 'viewTabs',
    anchor: ProductTourAnchorType.DatabaseViewTabs,
    titleTranslationKey: 'productTour.database.viewTabs.title',
    descriptionTranslationKey: 'productTour.database.viewTabs.description',
    placement: 'bottom',
  },
  {
    name: 'views',
    anchor: ProductTourAnchorType.DatabaseAddView,
    titleTranslationKey: 'productTour.database.views.title',
    descriptionTranslationKey: 'productTour.database.views.description',
    placement: 'bottom',
  },
  {
    name: 'group',
    anchor: ProductTourAnchorType.DatabaseGroupBy,
    titleTranslationKey: 'productTour.database.group.title',
    descriptionTranslationKey: 'productTour.database.group.description',
    placement: 'bottom',
  },
  {
    name: 'search',
    anchor: ProductTourAnchorType.DatabaseSearch,
    titleTranslationKey: 'productTour.database.search.title',
    descriptionTranslationKey: 'productTour.database.search.description',
    placement: 'bottom',
  },
  {
    name: 'filters',
    anchor: ProductTourAnchorType.DatabaseFilters,
    titleTranslationKey: 'productTour.database.filters.title',
    descriptionTranslationKey: 'productTour.database.filters.description',
    placement: 'bottom',
  },
  {
    name: 'peopleFilter',
    anchor: ProductTourAnchorType.DatabasePeopleFilter,
    titleTranslationKey: 'productTour.database.peopleFilter.title',
    descriptionTranslationKey: 'productTour.database.peopleFilter.description',
    placement: 'bottom',
  },
  {
    name: 'sort',
    anchor: ProductTourAnchorType.DatabaseSort,
    titleTranslationKey: 'productTour.database.sort.title',
    descriptionTranslationKey: 'productTour.database.sort.description',
    placement: 'bottom',
  },
  {
    name: 'hiddenColumns',
    anchor: ProductTourAnchorType.DatabaseHiddenProperties,
    titleTranslationKey: 'productTour.database.hiddenColumns.title',
    descriptionTranslationKey: 'productTour.database.hiddenColumns.description',
    placement: 'bottom',
  },
  {
    name: 'records',
    anchor: ProductTourAnchorType.DatabaseAddItem,
    titleTranslationKey: 'productTour.database.records.title',
    descriptionTranslationKey: 'productTour.database.records.description',
    placement: 'bottom',
  },
  {
    name: 'recordsInGroup',
    // The canvas renderer paints this button, so TableCanvasContainer exposes a
    // positioned marker carrying the same anchor while the database tour runs;
    // the DOM table renders the anchor on the real button
    anchor: ProductTourAnchorType.DatabaseAddItemInGroup,
    fallbackAnchor: ProductTourAnchorType.DatabaseTable,
    titleTranslationKey: 'productTour.database.recordsInGroup.title',
    descriptionTranslationKey: 'productTour.database.recordsInGroup.description',
    placement: 'top',
  },
  {
    name: 'properties',
    // Same canvas marker mechanism as recordsInGroup
    anchor: ProductTourAnchorType.DatabaseAddProperty,
    titleTranslationKey: 'productTour.database.properties.title',
    descriptionTranslationKey: 'productTour.database.properties.description',
    placement: 'left',
  },
]
